import axios from '../../utils/axios'

export const getVideos = async (tags, search, page, limit, author) => {
  let queryString = ''

  if (tags?.length > 0) {
    queryString += tags.map((tag) => `tags_like=${tag}`).join('&')
  }

  if (search !== '') {
    queryString += `&q=${search}`
  }
  //console.log(page,limit)
  const response = author
    ? {
        totalCount: await axios.get(`/videos/?${queryString}&author=${author}`),
        data: await axios.get(
          `/videos/?${queryString}&author=${author}&_start=${page}&_limit=${limit}`,
        ),
      }
    : {
        totalCount: await axios.get(`/videos/?${queryString}`),
        data: await axios.get(`/videos/?${queryString}&_start=${page}&_limit=${limit}`),
      }

  return {
    totalCount: response?.totalCount?.data?.length,
    data: response?.data?.data,
  }
}
